import { makeStyles } from '@material-ui/core';

export const useTypographyStyles = makeStyles(() => ({
  patientProfileCardTitle: {
    marginTop: 0,
    marginBottom: 0,
  },
}));
